import { AlertStatesBaseCountersModel } from './alert-states-base-counters-model';

export class AlertStatesConfigurationCountersModel extends AlertStatesBaseCountersModel {
}
